import type { AppRouteModule } from "/@/router/types";

import { LAYOUT } from "/@/router/constant";

const autoGenerate: AppRouteModule = {
  path: "/autoGenereate",
  name: "autoGenereate",
  component: LAYOUT,
  redirect: "/autoGenereate/index",
  meta: {
    hideChildrenInMenu: false,
    icon: "ant-design:android-outlined",
    title: "软文自动生成",
    orderNo: 2,
  },
  children: [
    {
      path: "apiKeys",
      name: "GPTAPIKeys",
      component: () => import("/@/views/autoGenerate/apiKeys.vue"),
      meta: {
        title: "chatGPT令牌",
        hideMenu: false,
      },
    },
    {
      path: "index",
      name: "GPTIndex",
      component: () => import("/@/views/autoGenerate/index.vue"),
      meta: {
        title: "软文生成",
        hideMenu: false,
      },
    },
  ],
};

export default autoGenerate;
